import React from 'react';
import { abbreviateNumber } from '@pascal/pascal-core';
import { defineChipColor } from '../../helpers/chipColor';
import { BET_TYPE } from '../../enums/actionTypes';

function MainBetChip({ boxAmountByBetType, handleDoChip, quickBets, boxIndex, activeFreeBet }) {
  return (
    <div
      className={`tb-chip tb-player-chip ${
        activeFreeBet.id && boxAmountByBetType[BET_TYPE.main]?.amount
          ? 'free-chip'
          : defineChipColor(boxAmountByBetType[BET_TYPE.main]?.amount || 0, quickBets) || ''
      }  ${
        abbreviateNumber(boxAmountByBetType[BET_TYPE.main]?.amount || 0).toString().length > 3
          ? ''
          : 'large'
      }`}
      onClick={() => handleDoChip(boxIndex, BET_TYPE.main)}
    >
      {boxAmountByBetType[BET_TYPE.main]?.amount
        ? abbreviateNumber(boxAmountByBetType[BET_TYPE.main]?.amount)
        : null}
    </div>
  );
}

export default MainBetChip;
